import { services } from '@billow/js-helpers'
import Account from './models/Account'
import ApiClient from './models/ApiClient'
import ApiKey from './models/ApiKey'
import backend from '@/api/auth'
import User from './models/User'
import { get } from '@/api/request'

export default {

  namespaced: true,

  state: {
    user: new User,
    apiKey: new ApiKey,
    account: new Account(),
    devEnvClient: new ApiClient(),

    plans: [],
    
    invoices: [],

    overview: {
      operations: {
        total: 0,
        for_the_month: 0,
        for_last_month: 0,
        this_time_last_month: 0
      }
    },

    card: {}
  },

  mutations: {
    ...User.commonMutations(),
    ...User.authMutations(),
    ...ApiKey.mutations(),
    ...Account.mutations(),

    setPlans: (state, plans) => (state.plans = plans),
    setAccountOverview: (state, overview) => (state.overview = overview),
    setDevEnvClient: (state, client) => (state.devEnvClient = new ApiClient(client)),
    setDevEnvSecret: (state, secret) => (state.devEnvClient.secret = secret),
    setCard: (state, card) => state.card = card,
    setInvoices: (state, invoices) => state.invoices = invoices,
  },

  actions: {
    signUp: ({ state }) => new Promise((resolve, reject) => backend.signup(state.user, () => {
      resolve()
    }, reject)),

    authenticate: ({ state, dispatch }) => new Promise((resolve, reject) => {
      get('/sanctum/csrf-cookie', () => {
        backend.authenticate({
          email: state.user.email,
          password: state.user.password
        }, async ({ data }) => {
          resolve(data)
        }, reject)
      }, error => {})
    }),

    loadUser: ({ commit }) => new Promise((resolve, reject) => backend.loadAuthUser(({ data }) => {
      commit('setUser', data)
      resolve(data.user)
    }, reject)),

    loadApiKeys: ({ commit }) => new Promise((resolve, reject) => backend.loadApiKeys(({ data }) => {
      commit('setApiKey', data)
      resolve(data.user)
    }, reject)),

    loadAccount: ({ commit }) => new Promise((resolve, reject) => backend.loadAccount(({ data }) => {
      commit('setAccount', data)
      resolve()
    }, reject)),

    loadPlans: ({ commit }) => new Promise((resolve, reject) => backend.loadPlans(({ data }) => {
      commit('setPlans', data)
      resolve()
    }, reject)),
    
    loadCard: ({ commit }) => new Promise((resolve, reject) => backend.loadCard(({ data }) => {
      commit('setCard', data)
      resolve()
    }, reject)),

    loadAccountOverview: ({ commit }) => new Promise((resolve, reject) => backend.loadAccountOverview(({ data }) => {
      commit('setAccountOverview', data)
      resolve()
    }, reject)),

    uploadProfilePicture: ({ commit }, payload) => new Promise((resolve, reject) => backend.uploadProfilePicture(payload, ({ data }) => {
      commit('setProfilePictureUrl', data)
      resolve()
    }, reject)),
    
    updateAccount: ({ state }) => new Promise((resolve, reject) => backend.updateAccount(state.account, resolve, reject)),
    updateProfile: ({ state }) => new Promise((resolve, reject) => backend.updateProfile(state.user, resolve, reject)),
    subscribeToPlan: ({}, payload) => new Promise((resolve, reject) => backend.subscribeToPlan(payload, ({data}) => {
      resolve(data)
    }, reject)),
    logout: ({ commit }) => new Promise((resolve, reject) => backend.logout(() => {
      commit('clearUser')
      commit('clearAccount')
      resolve()
    }, () => {
      commit('clearUser')
      commit('clearAccount')
      reject()
    })),
    enable2Fa: ({commit}) => new Promise((resolve, reject) => {
      backend.enable2Fa(({data}) => {
        console.log(data)
        commit('set2FaSecret', data)
        resolve()
      }, reject)
    }),
    disable2Fa: ({commit}) => new Promise((resolve, reject) => {
      backend.disable2Fa(() => {
        commit('disable2Fa')
        resolve()
      }, reject)
    }),
    get2FaQrCode: ({}) => new Promise((resolve, reject) => {
      backend.get2FaQrCode(resolve, reject)
    }),
    get2FaRecoveryCodes: ({}) => new Promise((resolve, reject) => {
      backend.get2FaRecoveryCodes(resolve, reject)
    }),
    send2FaChallenge: ({}, payload) => new Promise((resolve, reject) => {
      backend.send2FaChallenge(payload, resolve, reject)
    }),
    finalise2FaSetup: ({commit}, payload) => new Promise((resolve, reject) => {
      backend.finalise2FaSetup(payload, () => {
        commit('set2Fa')
        resolve()
      }, reject)
    }),

    loadLatestInvoices: ({commit}) => new Promise((resolve, reject) => {
      backend.loadLatestInvoices(({data}) => {
        commit('setInvoices', data)
        resolve()
      }, reject)
    })
  },

  getters: {
    user: state => state.user,
    account: state => state.account,
    activeAcountId: state => state.account.id,
    accountOverview: state => state.overview,
    plans: state => state.plans,
    devEnvClient: state => state.devEnvClient,
    canSignIn: state => state.user.email && state.user.password,
    canSignUp: state => state.user.name && state.user.email && state.user.password,
    card: state => state.card,
    invoices: state => state.invoices,
  }

}
